module.exports = __webpack_public_path__ + "img/pantalla-1-3-3.87e3080b.png";